import { render, staticRenderFns } from "./pendingOfficers.vue?vue&type=template&id=32184f4d"
import script from "./pendingOfficers.vue?vue&type=script&lang=js"
export * from "./pendingOfficers.vue?vue&type=script&lang=js"
import style0 from "./pendingOfficers.vue?vue&type=style&index=0&id=32184f4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports